<template>
    <div class="login-page-container">
        <h1 class="login-header">Welcome to ChatFight</h1>
        <p v-if="errorMessage" class="login-error">{{ errorMessage }}</p>
        <!--
            Plain anchor (NOT a button with @click). The OAuth state nonce is generated
            server-side; we have to navigate the *browser* to /auth/twitch so the server
            can mint state, set the redirect, and send the user on to Twitch. JS-driven
            window.location.href would work but a plain anchor is what the Twitch flow
            wants and is what 2.2 (Discord) will mirror.
        -->
        <a href="/auth/twitch" class="twitch-login-btn">
            Login with Twitch
        </a>
        <!--
            Mirrors the Twitch button per discord-2.2. The server-side flow does the same
            things in /auth/discord that /auth/twitch does — mints OAuth state via
            OAuthStateService, redirects to Discord, on callback validates state and mints
            a cf_session cookie. No client_id / client_secret embedded; no client-side
            OAuth handling.
        -->
        <a href="/auth/discord" class="discord-login-btn">
            Login with Discord
        </a>
    </div>
</template>


<script>

export default {
    data() {
        return {
            // OAuth callback failures redirect here with ?error=<code>. Show a friendly hint;
            // the codes themselves come from server/src/middleware/oauthStateMiddleware.ts and
            // server/src/twitchSetup.ts (currently: oauth_state, oauth_callback).
            errorMessage: '',
        };
    },
    created() {
        const err = this.$route?.query?.error;
        if (err === 'oauth_state') {
            this.errorMessage = 'Your login session expired or was tampered with. Please try again.';
        } else if (err === 'oauth_callback') {
            // Same error code is emitted by both Twitch and Discord callback handlers
            // (server/src/twitchSetup.ts and server/src/discordSetup.ts). The message
            // is intentionally provider-neutral.
            this.errorMessage = 'We could not complete the login. Please try again.';
        }
    },
}

</script>

<style>
.login-page-container {
    width: 100%;
    height: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.login-header {
    color: white;
}
.login-error {
    color: #ff7676;
    margin-bottom: 12px;
}
.twitch-login-btn {
    background-color: #995BD5;
    width: 90%;
    max-width: 200px;
    height: 40px;
    color: white;
    border-radius: 4px;
    align-self: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
}
.twitch-login-btn:hover {
    background-color: #8849c4;
}
/* Discord brand color "blurple" (#5865F2). Geometry matches .twitch-login-btn
   so the two buttons stack predictably. Vertical gap added via top margin
   here rather than a layout wrapper to keep the diff minimal. */
.discord-login-btn {
    background-color: #5865F2;
    width: 90%;
    max-width: 200px;
    height: 40px;
    color: white;
    border-radius: 4px;
    align-self: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    margin-top: 12px;
}
.discord-login-btn:hover {
    background-color: #4752c4;
}
</style>
